const NS = 'ProgramCoursesItemWidget';
const CLS = 'programCoursesItemWidget';

import { handleTruncate } from '../../../../global/js/wlc/truncate';

export class ProgramCoursesItemWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$toggler = this.$element.find(`.${CLS}-toggler`);
		this.$toggler.on('click', () => {
			if(!this.$element.hasClass(`${CLS}--compact`)) {
				this.$element.addClass(`${CLS}--compact`);
			}
			else {
				this.$element.removeClass(`${CLS}--compact`);
			}
		});

		this.$contentDescription = this.$element.find(`.${CLS}-content-description`);

		handleTruncate(this.$contentDescription, 300);
	}
}
